import { render, staticRenderFns } from "./privod.vue?vue&type=template&id=413b1433&scoped=true&"
import script from "./privod.vue?vue&type=script&lang=js&"
export * from "./privod.vue?vue&type=script&lang=js&"
import style0 from "./privod.vue?vue&type=style&index=0&id=413b1433&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413b1433",
  null
  
)

export default component.exports